import React from "react";
import { Box, Typography } from "@mui/material";
import mark from "assets/images/logos/fusionmsi-logo.svg";

/**
 * The Fusion MSI mark and name. The name is type, not an image, so it takes the
 * theme's text colour and needs no separate dark-mode file.
 * Mark: satin blue/gold star (canonical fusionmsi-logo.svg / StarDraft3 / flash15).
 */
const Logo = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: 32 }}>
    <Box
      component="img"
      src={mark}
      alt=""
      sx={{ height: 32, width: "auto", display: "block" }}
    />
    <Typography variant="logo" component="span" color="text.primary" noWrap>
      Fusion MSI
    </Typography>
  </Box>
);

export default Logo;
